<script lang="ts">
  import filters from '../lib/stores/filters'
  import useFilter from '../hooks/use-filter'
  import Category from './Category.svelte'
  import CategorySection from './CategorySection.svelte'

  const { resetRegionCategory } = filters
  const { categories } = useFilter()
  const { id, hory } = categories.region
</script>

<Category {id} on:reset={() => resetRegionCategory(hory.defaultValue)}>
  <CategorySection>
    <ul class="grid gap-1 sm:grid-cols-2 sm:gap-1.5">
      {#each hory.options as region (region.value)}
        <li>
          <label
            class="block cursor-pointer p-0.5"
            class:font-bold={$filters.hory === region.value}
            class:bg-gray-300={$filters.hory === region.value}
          >
            <input
              type="radio"
              bind:group={$filters.hory}
              name="hory"
              value={region.value}
              class="hidden"
            />
            <span>{@html region.text}</span>
          </label>
        </li>
      {/each}
    </ul>
  </CategorySection>
</Category>
